import { withStyles } from '@material-ui/core';

import Remove from './component';
import styles from './styles';

export default withStyles(styles)(Remove);
